<template>
  <div class="main">

    <lnb></lnb>

    <!--SECTION-->
    <section class="sec1">
      <img src="img/visual_main.png" alt="지미추 메인 비주얼" class="bg">
      <img src="img/txt_maintitle.png" alt="BRIDAL BOUTIQUE" class="title to-bottom">
      <img src="img/txt_mainsubtitle.png" alt="SUB BRIDAL BOUTIQUE" class="sub_title to-bottom">
      <img src="img/txt_maindesc.png" alt="당신에게 생애 최고의 결혼식을 선물합니다." class="desc to-bottom">
      <div class="scroll">
        <img src="img/txt_mainscroll.png" alt="scroll" class="text to-top">
        <div class="line to-top">
          <img src="img/main_scrollline.png" alt="scroll line">
        </div>
      </div>
    </section>


    <!--SECTION-->
    <section class="sec2">
      <img src="img/prod_shoe.png" alt="구두" class="shoe rellax" data-rellax-speed="4.5" data-rellax-percentage="1">
      <img src="img/mark_jimmy_white.png" alt="jimmy" class="mark_jimmy rellax" data-rellax-speed="-2" data-rellax-percentage="1">
      <img src="img/txt_bridalboutique_title.png" alt="" class="title rellax" data-rellax-speed="2" data-rellax-percentage="0">
      <img src="img/txt_bridalboutique_desc.png" alt="" class="desc rellax" data-rellax-speed="2" data-rellax-percentage="0">
      <a @click="changeContentsName('Sub2')" class="btn rellax" data-rellax-speed="2" data-rellax-percentage="0"></a>
    </section>


    <!--SECTION-->
    <section class="sec3">
      <img src="img/mark_c_white.png" alt="" class="mark_c rellax" data-rellax-speed="-2" data-rellax-percentage="0">
      <img src="img/pic_madetoorder.png" alt="" class="pic rellax" data-rellax-speed="-1" data-rellax-percentage="0">
      <img src="img/txt_madetoorder_title.png" alt="" class="title rellax" data-rellax-speed="0" data-rellax-percentage="0">
      <img src="img/txt_madetoorder_desc1.png" alt="" class="desc1 rellax" data-rellax-speed="0" data-rellax-percentage="0">
      <img src="img/txt_madetoorder_desc2.png" alt="" class="desc2 rellax" data-rellax-speed="0" data-rellax-percentage="0">
      <img src="img/txt_madetoorder_desc3.png" alt="" class="desc3 rellax" data-rellax-speed="0" data-rellax-percentage="0">
      <img src="/img/txt_side.png" alt="" class="txt_side rellax" data-rellax-speed="2" data-rellax-percentage="0">
    </section>


    <!--SECTION-->
    <section class="sec4">
      <div class="pink_box"></div>
      <img src="img/pic_personalstylingservice.png" alt="" class="pic rellax" data-rellax-speed="0.5" data-rellax-percentage="0">
      <img src="img/mark_h_pink.png" alt="" class="mark_h rellax" data-rellax-speed="-1" data-rellax-percentage="0.5">
      <img src="img/prod_minibag.png" alt="" class="prod_thumb rellax" data-rellax-speed="0" data-rellax-percentage="0">
      <img src="img/txt_personalstyling_title.png" alt="" class="title rellax" data-rellax-speed="0" data-rellax-percentage="0">
      <img src="img/txt_personalstyling_desc.png" alt="" class="desc rellax" data-rellax-speed="0" data-rellax-percentage="0">
      <a @click="changeContentsName('Sub5')" class="btn rellax" data-rellax-speed="0" data-rellax-percentage="0"></a>
    </section>


    <!--SECTION-->
    <section class="sec5">
      <div class="pink_box1"></div>
      <div class="pink_box2"></div>
      <img src="img/mark_o_white.png" alt="" class="mark_o rellax" data-rellax-speed="-1" data-rellax-percentage="0">
      <img src="img/pic_lookbook.png" alt="" class="pic rellax" data-rellax-speed="0.5" data-rellax-percentage="0">
      <img src="img/txt_side.png" alt="" class="txt_side rellax" data-rellax-speed="2" data-rellax-percentage="0">
      <img src="img/txt_lookbook_title.png" alt="" class="title rellax" data-rellax-speed="0.5" data-rellax-percentage="0">
      <img src="img/prod_bag.png" alt="" class="prod rellax" data-rellax-speed="5" data-rellax-percentage="0.5">
      <a @click="changeContentsName('Sub4')" class="btn rellax" data-rellax-speed="0.5" data-rellax-percentage="0"></a>
    </section>


    <!--SECTION-->
    <section class="sec6">
      <div class="video_area">
        <div id="player"></div>
      </div>
    </section>


    <!--SECTION-->
    <section class="sec7">
      <div class="pink_box3 rellax" data-rellax-speed="1" data-rellax-percentage="0"></div>
      <img src="img/mark_o_pink.png" alt="" class="mark_o rellax" data-rellax-speed="-2" data-rellax-percentage=".5">
      <img src="img/txt_side.png" alt="" class="txt_side rellax" data-rellax-speed="3" data-rellax-percentage="1">
      <ul class="instagram clearfix rellax" data-rellax-speed="1.5" data-rellax-percentage="0.5">
        <li><img src="img/instagram_1.png" alt=""></li>
        <li><img src="img/instagram_2.png" alt=""></li>
        <li><img src="img/instagram_3.png" alt=""></li>
        <li><img src="img/instagram_4.png" alt=""></li>
      </ul>
      <img src="img/txt_instagram_title.png" alt="" class="title rellax" data-rellax-speed="1" data-rellax-percentage="0">
      <a href="https://www.instagram.com/jimmychoo/?hl=ko" class="btn rellax" data-rellax-speed="1" data-rellax-percentage="0"></a>
    </section>


    <!--SECTION-->
    <section class="sec8">
      <div class="pink_box4"></div>
      <img src="img/pic_findaboutique.png" alt="" class="pic rellax" data-rellax-speed="1" data-rellax-percentage="0">
      <img src="img/txt_findaboutique.png" alt="" class="title rellax" data-rellax-speed="5" data-rellax-percentage="0.5">
      <a @click="changeContentsName('Sub6')" class="btn rellax" data-rellax-speed="5" data-rellax-percentage="0.2"></a>
    </section>

  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import Lnb from './Lnb.vue'

  export default {
    name: 'MainPage',
    components: {
      Lnb
    },
    data () {
      return {

      }
    },
    methods: {
      ...mapMutations([
        'changeContentsName'
      ]),
      toBottom () {
        TweenMax.set('.to-bottom', { y: -100, opacity: 0 })
        TweenMax.staggerTo('.to-bottom', 1, { delay: .7, y: 0, opacity: 1 }, .3)
      },
      toTop () {
        TweenMax.set('.to-top', { y: 100, opacity: 0 })
        TweenMax.staggerTo('.to-top', 1, { delay: .7, y: 0, opacity: 1 }, .3)
      }
    },
    mounted () {
      this.toBottom()
      this.toTop()

      TweenMax.to('.scroll .line img', 2, { y: 102, repeat: -1 })

      setTimeout(() => {
        new Rellax('.rellax');
      }, 200)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/MainPage.vue